import ITask from '../../../Utility/Task/ITask';
import CardSystem, { getCardHandler } from '../CardSystem';
import CardStateAnimationHelper from './CardStateAnimationHelper';
import LevelTaskHelper from '../../LevelTaskHelper';
import AudioStateHelper from '../../../State/Audio/AudioStateHelper';

export default class CardStateSyncTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        const state = system.store.getState();
        if (state.levelState.cardsState.tasks) {
            for (const taskData of state.levelState.cardsState.tasks) {
                CardStateAnimationHelper.handleEarlyTask(system, taskData);
            }
        }

        for (const cardID in state.levelState.cardsState.cards) {
            getCardHandler(system.getCardByID(cardID)).handleStateChange(
                state,
                system
            );
        }

        system.sortCardsInPlay(state.levelState.cardsState);

        if (state.levelState.tasks) {
            for (let i = state.levelState.tasks.length - 1; i >= 0; i--) {
                const taskData = state.levelState.tasks[i];
                if(!LevelTaskHelper.handleTask(system, taskData)) {
                    state.levelState.tasks.splice(i, 1);
                }
            }
        }

        if (state.levelState.cardsState.tasks) {
            // it will play a sound for the task if there is one
            AudioStateHelper.cardTask(state.levelState.cardsState.tasks);

            for (const taskData of state.levelState.cardsState.tasks) {
                CardStateAnimationHelper.handleTask(system, taskData);
            }
        }
    }
}
